module.exports = __webpack_public_path__ + "static/media/setup-warning.9e730388.svg";